var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgText = function SvgText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 10.5a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-1.5 0v-13.5a.75.75 0 0 1 .75-.75Z",
    fill: "#3D4043"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 11.25a.75.75 0 0 1 .75-.75h15a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0V12h-13.5v2.25a.75.75 0 0 1-1.5 0v-3ZM18.25 24.75A.75.75 0 0 1 19 24h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75Z",
    fill: "#3D4043"
  })));
};
export default SvgText;